import type { filtersType } from '../../../components/v2/filters/interfaces'

export const getFilters = ({
  currentFilters,
  availableFilters,
  isGoLeader,
  isBrandLeader,
  isMeasurer,
}): filtersType[] => {
  const filters = [
    {
      name: 'id',
      label: 'Найти замер',
      placeholder: 'Найти замер',
      prefix: 'ID',
      type: 'input-integer',
      value: currentFilters?.id,
      options: {
        width: '170px',
      },
    },
    {
      name: 'stage',
      label: 'Фильтр по стадии',
      placeholder: 'Выберите стадию',
      type: 'select_multiple',
      value: currentFilters?.stage,
      options: {
        enum: availableFilters?.stage,
      },
    },
    {
      name: 'manager',
      label: 'Менеджер',
      placeholder: 'Выберите менеджера',
      type: 'select',
      value: currentFilters?.manager,
      options: {
        enum: availableFilters?.manager,
      },
    },
    {
      name: 'dates',
      label: 'Дата планового замера',
      type: 'dates',
      options: {
        tooltip: 'Дата планового замера',
      },
      value: currentFilters?.dates,
    },
    {
      name: 'measurement_dates',
      label: 'Дата фактического замера',
      type: 'dates',
      options: {
        tooltip: 'Дата фактического замера',
      },
      value: currentFilters?.measurement_dates,
    },
    {
      name: 'production_number',
      label: 'Номер производственного заказа',
      placeholder: 'Номер производственного заказа',
      type: 'input-string',
      value: currentFilters?.production_number,
    },
  ]
  if (!isMeasurer) {
    filters.push({
      name: 'responsible',
      label: 'Ответственный за замер',
      placeholder: 'Выберите ответственного',
      type: 'select',
      value: currentFilters?.responsible,
      options: {
        enum: availableFilters?.responsible,
      },
    })
  }
  if (isGoLeader || isBrandLeader) {
    filters.push({
      name: 'office',
      label: 'Офис',
      placeholder: 'Выберите офис',
      type: 'select',
      value: currentFilters?.office,
      options: {
        enum: availableFilters?.office || [],
      },
    })
  }
  if (isMeasurer || isGoLeader) {
    filters.push({
      name: 'brand',
      label: 'Бренд',
      placeholder: 'Выберите бренд',
      type: 'select',
      value: currentFilters?.brand,
      options: {
        enum: availableFilters?.brand || [],
      },
    })
  }

  return filters as filtersType[]
}
